import Icon from '../components/Icon'

Icon.register({
  'user-injured': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M277.4 12l-90.7 68h-81.2c19-46.9 64.8-80 118.5-80 19.1 0 37.1 4.5 53.4 12zM342.5 80h-102.5l66-49.5c15.8 13.3 28.6 30 36.5 49.5zM224 256c-70.7 0-128-57.3-128-128 0-5.5 0.9-10.7 1.6-16h252.8c0.7 5.3 1.6 10.5 1.6 16 0 70.7-57.3 128-128 128zM80 299.7c9.3-4.1 19.5-7.3 29.8-9.2l98.5 221.5h-128.3v-212.3zM0 464v-41.6c0-41.1 18.9-77.5 48-102.2v191.8c-26.5 0-48-21.5-48-48zM256 416c26.5 0 48 21.5 48 48s-21.5 48-48 48h-12.7l-42.7-96h55.4zM313.6 288c74.2 0 134.4 60.2 134.4 134.4v41.6c0 26.5-21.5 48-48 48h-80.4c10.2-13.4 16.4-29.9 16.4-48 0-44.1-35.9-80-80-80h-69.6l-42.7-96h7.4c22.2 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7z'
      }
    ]
  }
})
